import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "progress-bar" }
const _hoisted_2 = {
  key: 0,
  class: "progress-bar--label"
}
const _hoisted_3 = { class: "progress-bar--component" }
const _hoisted_4 = { class: "progress-bar--component--container" }
const _hoisted_5 = {
  key: 0,
  class: "progress-bar--component--value"
}

import { computed } from 'vue'
import ProgressBar from 'primevue/progressbar'

interface Props {
    label?: string
    value: number
    showValue?: boolean
    barColor?: string
    backgroundColor?: string
    maxWidth?: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    label: { default: '' },
    value: {},
    showValue: { type: Boolean, default: true },
    barColor: { default: '{primary.500}' },
    backgroundColor: { default: '{gray.200}' },
    maxWidth: { default: '100%' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "125d3136": (_ctx.$props.maxWidth)
}))

const props = __props

const customStyle = computed(() => ({
    valueBackground: props.barColor,
    background: props.backgroundColor,
    height: '8px',
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(ProgressBar), _mergeProps({
          value: props.value,
          "show-value": false,
          dt: customStyle.value
        }, _ctx.$attrs), null, 16, ["value", "dt"])
      ]),
      (props.showValue)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.value) + "% ", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})